import { render, staticRenderFns } from "./VendorList.vue?vue&type=template&id=0c8841ba&scoped=true&"
import script from "./VendorList.vue?vue&type=script&lang=js&"
export * from "./VendorList.vue?vue&type=script&lang=js&"
import style0 from "./VendorList.vue?vue&type=style&index=0&id=0c8841ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8841ba",
  null
  
)

export default component.exports